import EducationForm from '@/components/dashboard/members/profile/education/EducationForm'
import { Education, RemoveEducationDocument } from '@/types/graphql/types'
import { getErrorMessage } from '@/util/getErrorMessage'
import { useMutation } from '@apollo/client'
import { Text, useMantineTheme } from '@mantine/core'
import { useModals } from '@mantine/modals'
import { showNotification } from '@mantine/notifications'
import { parseInt } from 'lodash'
import useTranslation from 'next-translate/useTranslation'
import { useRouter } from 'next/router'

const useEducationItem = ({
  education,
  handleUpdateEducations,
}: {
  education: Education
  handleUpdateEducations: ({
    newEducations,
  }: {
    newEducations: Education[]
  }) => void
}) => {
  const { t } = useTranslation('common')
  const modals = useModals()
  const { query } = useRouter()

  //open education update form
  const openEducationForm = (ed: Education) =>
    modals.openModal({
      title: t('education'),
      children: (
        <EducationForm
          education={ed}
          handleUpdateEducations={handleUpdateEducations}
        />
      ),
    })
  //remove education mutation
  const [removeEducation, { loading }] = useMutation(RemoveEducationDocument, {
    onCompleted(data) {
      handleUpdateEducations({
        newEducations: data.removeEducation as Education[],
      })
      modals.closeAll()
      showNotification({
        title: t('removed'),
        message: t('removedSuccessfully'),
      })
    },
    onError(error) {
      showNotification({
        title: t('error'),
        message: getErrorMessage(error),
        color: 'red',
        autoClose: false,
      })
    },
  })
  //open confirm education remove modal
  const openDeleteMessage = (id: number) =>
    modals.openConfirmModal({
      title: t('education'),
      children: <Text size="sm">{t('removeEducationMessage')}</Text>,
      labels: { confirm: t('confirm'), cancel: t('cancel') },
      async onConfirm() {
        await removeEducation({
          variables: {
            data: {
              educationId: id,
              userId: parseInt(query.id as string),
            },
          },
        })
      },
    })

  return { openEducationForm, openDeleteMessage, removeEducation, loading }
}

export default useEducationItem
